export default __webpack_public_path__ + "static/media/filter.7c167af6.svg";